import { useCopyToClipboard } from "../../hooks/useCopyToClipboard";
import clsx from "clsx";
import { HTMLAttributes } from "preact/compat";

type CopyToClipboardTriggerProps = HTMLAttributes<HTMLButtonElement> & {
  text: string;
  color?: string;
};

export const CopyToClipboardTrigger = ({
  text,
  color = 'black',
  children = "COPY LINK",
}: CopyToClipboardTriggerProps) => {
  const [copy, copyResult] = useCopyToClipboard();

  const handleCopy = () => {
    copy(text);
  };

  const isSuccess = copyResult !== null && copyResult.state === "success";

  return (
    <button
      onClick={handleCopy}
      className={clsx(
        "relative transition-opacity duration-200",
        {
          "opacity-50 ": isSuccess,
          " opacity-100": !isSuccess,
        }
      )}
      style={{ color }}
      disabled={isSuccess}
    >
      {children}

      <div className="absolute right-4 top-1/2 -translate-y-1/2 h-4 w-5 flex items-center justify-center">
        {isSuccess ? (
          <svg
            className="animate-draw-svg stroke-green-500 [stroke-dasharray:100] [stroke-dashoffset:100]"
            width="14"
            height="12"
            viewBox="0 0 14 12"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 6.4L4.63025 10L12.6975 1"
              stroke="currentColor"
              strokeWidth="2"
            />
          </svg>
        ) : (
          <svg
            width="14"
            height="16"
            viewBox="0 0 16 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M3.15385 1.06262H2C1.44772 1.06262 1 1.51034 1 2.06262V16C1 16.5523 1.44772 17 2 17H14C14.5523 17 15 16.5523 15 16V2.06262C15 1.51034 14.5523 1.06262 14 1.06262H12.8462"
              stroke="currentColor"
              strokeWidth="1.5"
            />
            <mask id="path-2-inside-1_562_170" fill="white">
              <rect x="4.23047" width="7.53846" height="5.31248" rx="1" />
            </mask>
            <rect
              x="4.23047"
              width="7.53846"
              height="5.31248"
              rx="1"
              stroke="currentColor"
              strokeWidth="3"
              mask="url(#path-2-inside-1_562_170)"
            />
          </svg>
        )}
      </div>
    </button>
  );
};
